import {
  CompletedCheckIcon,
  CompletedDisc,
} from 'containers/user/learn/containers/content/cources/course-details/course-sidebar/course-sidebar-item/lesson-completed-indicator.styles';

const COMPLETED_LABEL = 'Completed';

interface LessonCompletedIndicatorProps {
  'data-testid'?: string;
}

const LessonCompletedIndicator = ({
  'data-testid': dataTestId,
}: LessonCompletedIndicatorProps) => (
  <CompletedDisc
    role="img"
    aria-label={COMPLETED_LABEL}
    data-testid={dataTestId}
  >
    <CompletedCheckIcon aria-hidden="true" focusable="false" />
  </CompletedDisc>
);

export default LessonCompletedIndicator;
